import { Lightbulb } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { AdminTheme } from "./adminTheme";

export function AdminAppearanceToggle({
  theme,
  onChange,
}: {
  theme: AdminTheme;
  onChange: (theme: AdminTheme) => void;
}) {
  const nextAppearance = theme.appearance === "dark" ? "light" : "dark";
  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className="h-9 w-9 shrink-0 rounded-full"
      title="Đổi giao diện sáng/tối Admin"
      aria-label="Đổi giao diện sáng/tối Admin"
      onClick={() => onChange({ ...theme, appearance: nextAppearance })}
    >
      <Lightbulb className="h-4 w-4" />
    </Button>
  );
}